import React from 'react';
import { string, node, shape } from 'prop-types';
import Cintillo from '.';

// REVISAR CINTILLO COMUNIDAD
const defaultTarget = {
  name: 'España',
  flags: {
    small:
      '//upload.wikimedia.org/wikipedia/commons/thumb/1/1b/Jolly-roger.svg/220px-Jolly-roger.svg.png'
  },
  backgroundColor: {
    lasexta: '#000000'
  }
};

export default ({ children, title, selectedTarget = defaultTarget }) => {
  const { flags, name, backgroundColor } = selectedTarget;
  return (
    <Cintillo
      title={title}
      imgProps={{
        src: `${flags?.small}`,
        alt: `${name}`
      }}
      backgroundColor={backgroundColor.lasexta}
      rightSide={children}
    />
  );
};

Cintillo.propTypes = {
  title: string,
  children: node
};

Cintillo.defaultProps = {
  children: undefined
};
